/**
 * API date-only values (Django DateField → "YYYY-MM-DD") must not be parsed with
 * `new Date(str)` alone — that is treated as UTC midnight and shifts the calendar
 * day in most US timezones. Use local calendar parsing instead.
 */

export function parseDateOnlyLocal(value) {
  if (value == null || value === '') return null;
  const part = String(value).split('T')[0];
  const [y, m, d] = part.split('-').map((x) => parseInt(x, 10));
  if (!Number.isFinite(y) || !Number.isFinite(m) || !Number.isFinite(d)) {
    const fallback = new Date(value);
    return Number.isNaN(fallback.getTime()) ? null : fallback;
  }
  return new Date(y, m - 1, d);
}

export function formatDateOnlyForDisplay(value) {
  const parsed = parseDateOnlyLocal(value);
  if (!parsed) return '—';
  return parsed.toLocaleDateString();
}
